import { render } from "./OccasionDesc.vue?vue&type=template&id=552a62a4"
import script from "./OccasionDesc.vue?vue&type=script&lang=js"
export * from "./OccasionDesc.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__